import { useEffect, useState } from 'react'
import useFirstRender from '../../hooks/FirstRender';
import LoadMore from '../../components/common/LoadMore';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useApiProgress } from '../../hooks/ApiProgress';
import { PATTERN_PATH, deletePattern, downloadPatternExcelFile, getPagePatterns, uploadPatternExcelFile } from '../../api/patternApi';
import { uploadPatternExcelFileAction } from '../../redux/feature/patternSlice';
import { ENTITY_IS_IN_USE_MESSAGE, EXCEL_VALIDATION_MESSAGE } from '../../utils/constants';
import readXlsxFile, { readSheetNames } from 'read-excel-file';
import { toast } from 'react-toastify';
import Input from '../../components/Input';
import { AiFillDelete, AiFillEdit } from 'react-icons/ai';
import Button from '../../components/Button';
import { GoPlus } from 'react-icons/go';
import { FaCloudDownloadAlt } from 'react-icons/fa';
import DeleteModal from '../../components/DeleteModal';
import { pageModel } from '../../utils/model';
import { setPatternSearchParamsAction } from '../../redux/feature/searchParamsSlice';

const PatternListPage = ({ title }) => {

    useEffect(() => {
        document.title = "İmperteks / " + title; // Sayfa başlığını güncelle
    }, [title]);

    const isFirstRender = useFirstRender()
    const nav = useNavigate()
    const dispatch = useDispatch()
    const [patternPage, setPatternPage] = useState(pageModel)
    const pendingApiCall = useApiProgress('get', `${PATTERN_PATH}/page`, false)
    const pendingApiCallDelete = useApiProgress('delete', `${PATTERN_PATH}`, false)
    const searchParams = useSelector(state => state.searchParams.pattern)
    const [isOpen, setIsOpen] = useState(false)
    const [deleteId, setDeleteId] = useState(undefined)
    const [searchTimer, setSearchTimer] = useState();

    useEffect(() => {
        loadPatterns({ size: 20, page: patternPage.number, ...searchParams })
    }, [])

    const onLoadMore = () => {
        if (!patternPage.last) {
            loadPatterns({ ...searchParams, lastId: patternPage.content[patternPage.content.length - 1]?.id })
        }
    }

    useEffect(() => {
        !isFirstRender && searching({ ...searchParams, page: 0 })
    }, [searchParams])

    const loadPatterns = (params) => {
        !pendingApiCall &&
            getPagePatterns(params)
                .then(res => {
                    setPatternPage(prevState => ({ ...res.data, content: [...prevState.content, ...res.data.content] }))
                })
    }

    const searching = async (params) => {
        if (searchTimer) clearTimeout(searchTimer);
        let timer = setTimeout(() => {
            getPagePatterns(params)
                .then(res => {
                    setPatternPage(res.data)
                })
        }, 500);
        setSearchTimer(timer);
    }

    const onClickDelete = () => {
        deletePattern(deleteId)
            .then(res => {
                setIsOpen(false)
                setPatternPage(prevState => ({ ...prevState, content: prevState.content.filter(p => p.id !== deleteId) }))
                toast.success('Silindi')
            }).catch(err => {
                toast.error(ENTITY_IS_IN_USE_MESSAGE)
            })
    }

    const downloadExcelFile = () => {
        downloadPatternExcelFile().then(res => {
            const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'desenler.xlsx';
            a.click();
            window.URL.revokeObjectURL(url);
        }).catch(err => {
            toast.error('Dosya indirilirken hata oluştu!')
        })
    }

    return (
        <div>
            <div className='mb-1 border-b border-zinc-300'>
                <label className='text-2xl'>
                    DESENLER
                </label>
            </div>
            <div className='flex gap-x-2 py-2 sticky top-0 bg-zinc-50'>
                <Button
                    text={<label className='flex items-center gap-x-1'><GoPlus />Yeni Desen</label>}
                    variant='green'
                    onClick={() => nav('/pattern/add')}
                />
                <label
                    className='bg-emerald-700 hover:bg-emerald-800 disabled:bg-emerald-500 flex items-center gap-x-1 px-2 py-1 text-white text-md rounded-sm'
                    htmlFor='excel-download'
                    onClick={downloadExcelFile}
                >
                    <FaCloudDownloadAlt />
                    <span> Excel İndir</span>
                </label>
            </div>
            <table className='w-full text-left text-zinc-900 mb-10 text-sm'>
                <thead className='text-xs uppercase tracking-wide sticky top-12 bg-zinc-50'>
                    <tr>
                        <th className='p-2 w-1/12'>Id</th>
                        <th className='p-2 w-3/12'>Desen Kodu</th>
                        <th className='p-2 w-3/12'>Desen Adı</th>
                        <th className='p-2 w-4/12'>Açıklama</th>
                        <th className='p-2 w-1/12'>Aksiyon</th>
                    </tr>
                </thead>
                <tbody>
                    <tr className='border-b items-center sticky top-20 bg-zinc-50'>
                        <td className='px-2'>
                            <Input
                                name="id"
                                placeholder='Id...'
                                value={searchParams.id}
                                onChange={e => dispatch(setPatternSearchParamsAction({ key: e.target.name, value: e.target.value }))}
                            />
                        </td>
                        <td className='px-2'>
                            <Input
                                name="code"
                                placeholder='Desen kodu...'
                                value={searchParams.code}
                                onChange={e => dispatch(setPatternSearchParamsAction({ key: e.target.name, value: e.target.value }))}
                            />
                        </td>
                        <td className='px-2'>
                            <Input
                                name="name"
                                placeholder='Desen adı...'
                                value={searchParams.name}
                                onChange={e => dispatch(setPatternSearchParamsAction({ key: e.target.name, value: e.target.value }))}
                            />
                        </td>
                        <td>
                        </td>
                        <td>
                        </td>
                    </tr>
                    {
                        patternPage.content.map((pattern, index) => (
                            <tr key={index} className='border-b items-center hover:bg-violet-100 duration-150'>
                                <td className='p-2'># {pattern.id} </td>
                                <td className='p-2'>{pattern.code} </td>
                                <td className='p-2'>{pattern.name}</td>
                                <td className='p-2 '>{pattern.description}</td>
                                <td className='p-2 items-center'>
                                    <div className='flex gap-x-3'>
                                        <span className='cursor-pointer hover:scale-125 hover:text-blue-600 duration-150' onClick={() => nav(`/pattern/edit/${pattern.id}`)}>
                                            <AiFillEdit />
                                        </span>
                                        <span
                                            className='cursor-pointer hover:scale-125 hover:text-red-600 duration-150'
                                            onClick={() => {
                                                setIsOpen(true)
                                                setDeleteId(pattern.id)
                                            }}
                                        >
                                            <AiFillDelete />
                                        </span>
                                    </div>
                                </td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>
            <LoadMore page={patternPage} pending={pendingApiCall} onLoadMore={onLoadMore} />
            <DeleteModal
                isOpen={isOpen}
                closeModal={() => setIsOpen(false)}
                onClick={onClickDelete}
                pendingApiCall={pendingApiCallDelete}
            />

        </div >
    )
}

export default PatternListPage